var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$fetchState.pending)?_c('skeleton-loader-page-head'):_c('div',[_c('page-header',{attrs:{"title":_vm.gymChain.name,"back-to":"/indoor"}}),_vm._v(" "),_c('nuxt-child',{attrs:{"gym-chain":_vm.gymChain}})],1),_vm._v(" "),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }